import { useQuery } from "@tanstack/react-query";
import useFetch from "../lib/useFetch";
import { IProductOffering } from "../types/products";
import { PaginatedResponse } from "../types/core";

const API = process.env.REACT_APP_API;

interface ProductOfferingsFilters {
  search?: string;
  producer?: number | null;
  category?: number | null;
}

const useProductOfferings = (
  fairId: number | null,
  page: number,
  ordering?: string,
  filters?: ProductOfferingsFilters,
) => {
  const fetch = useFetch();
  const searchTerm = filters?.search?.trim();

  return useQuery({
    queryKey: [
      "product-offerings",
      fairId,
      page,
      ordering,
      searchTerm,
      filters?.producer ?? null,
      filters?.category ?? null,
    ],
    queryFn: () => {
      if (!fairId) {
        throw new Error("Fair ID is required");
      }
      const searchParams = new URLSearchParams();
      searchParams.set("page", page.toString());
      if (ordering) {
        searchParams.set("ordering", ordering);
      }
      if (filters?.producer) {
        searchParams.set("producer", filters.producer.toString());
      }
      if (filters?.category) {
        searchParams.set("category", filters.category.toString());
      }
      if (searchTerm) {
        searchParams.set("search", searchTerm);
      }
      return fetch(
        `${API}/api/semeadora/fairs/${fairId}/offerings/?${searchParams.toString()}`,
        {
          method: "GET",
        },
      ) as Promise<PaginatedResponse<IProductOffering>>;
    },
    enabled: !!fairId,
    keepPreviousData: true,
    onError: (error) => {
      console.log("onError", error);
    },
  });
};

export default useProductOfferings;
